












import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

import Default from './components/common/Default.vue'

const UserModule = namespace('user')

@Component({ components: { Default } })
export default class App extends Vue {
  @UserModule.Getter('loading') loading!: boolean
}
